import { render, staticRenderFns } from "./DynamicInputs.vue?vue&type=template&id=256f3eec"
import script from "./DynamicInputs.vue?vue&type=script&lang=js"
export * from "./DynamicInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports